<div class="form-field">

  @if (!!icon) {
    <div class="icon-box">
      <uikit-icon [icon]="icon"></uikit-icon>
    </div>
  }
  <ng-content></ng-content>
</div>
